import { render, staticRenderFns } from "./rTagCom.vue?vue&type=template&id=85b16d78&scoped=true&"
import script from "./rTagCom.vue?vue&type=script&lang=ts&"
export * from "./rTagCom.vue?vue&type=script&lang=ts&"
import style0 from "./rTagCom.vue?vue&type=style&index=0&id=85b16d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b16d78",
  null
  
)

export default component.exports